/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain as PlaceOrderChain,
    DispatchCompletePlaceOrder,
    SetCartStatus,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { xCheckoutHandlers } from "@monsma/App/Store/Reducers";

export const XngPopulateCartExtraProps: any = (props: any) => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;

    if (!cart) {
        throw new Error("There was no current cart and we are trying to place the current cart as an order.");
    }

    const {
        deliveryMessaging,
        ltlDeliveryType,
        appointmentRequired,
        liftGateRequired,
        customerReference1,
    } = state.xCheckout;

    props.cartToUpdate = {
        ...props.cartToUpdate,
        properties: {
            ...props.cartToUpdate.properties,
            deliveryMessaging,
            ltlDeliveryType,
            appointmentRequired,
            liftGateRequired,
            customerReference1,
        },
    };
};

export const xClearCheckoutStatus = (props: any) => {
    const { setDeliveryMessaging, setLtlDeliveryType, setAppointmentRequired, setLiftGateRequired } = xCheckoutHandlers;

    setDeliveryMessaging("")(props.dispatch);
    setLtlDeliveryType("")(props.dispatch);
    setAppointmentRequired("")(props.dispatch);
    setLiftGateRequired("")(props.dispatch);
};

addToChainAfter(PlaceOrderChain, SetCartStatus, XngPopulateCartExtraProps);
addToChainAfter(PlaceOrderChain, DispatchCompletePlaceOrder, xClearCheckoutStatus);
